import { useValueLists } from "../app/hooks"

const useMultiValueListData = (listIds: string[], itemId: string) => {
  const lists = useValueLists()

  const filteredLists = lists?.filter((el) =>
    listIds.includes(el.valueListCode),
  )

  if (!filteredLists?.length) {
    return itemId
  }

  const concatenatedLists = filteredLists?.flatMap((el) => el.values)

  const item = concatenatedLists.find((el) => el.code === itemId)

  if (!item) {
    return itemId
  }

  return item.value
}

export default useMultiValueListData
